import { useQuery } from 'react-query';

import userService from 'resources/user/user.service';
import dealService from 'resources/deal/deal.service';

const getTransactionParties = async (dealId) => {
  if (!dealId) {
    return null;
  }

  const deal = await dealService.findById(dealId);

  const users = await userService.getUsersByIds([deal.realtor_id, ...deal.client_ids, deal.coordinator_id]);
  const agent = users.find((user) => user.id === deal.realtor_id);
  const coordinator = users.find((user) => user.id === deal.coordinator_id);
  const clients = users.filter((user) => deal.client_ids.includes(user.id));
  const transactionParties = [
    {
      ...agent,
      isAgent: true,
    },
    {
      ...coordinator,
      isCoordinator: true,
    },
    ...clients.map((client) => ({
      ...client,
      isClient: true,
    })),
  ];

  return transactionParties;
};

export default function useTransactionParties(dealId, queryOptions) {
  return useQuery(
    ['users.getTransactionParties', dealId],
    () => getTransactionParties(dealId),
    queryOptions,
  );
}
